import React, { useEffect, useState } from "react";
import { FormInstance, Input, Modal } from "antd";
import { MasterConfigs } from "../../interfaces/entity";
import DrawerComponent from "./Drawer";
import RenderForm from "./Form";
import './Style.scss';
import { useNavigate } from "react-router-dom";

interface Props {
    config: MasterConfigs;
    open: boolean;
    onClose: () => void;
    isModal?: boolean;
    id?: string;
    isView?: boolean;
    form?: (e: FormInstance) => void;
}

const FormSetup: React.FC<Props> = ({
    config,
    open,
    onClose,
    isModal = false,
    id,
    isView,
    form
}) => {
    const [currentForm, setCurrentForm] = useState<FormInstance>(null);
    const [visible, setVisible] = useState<boolean>(open);
    const [loading, setLoading] = useState<boolean>(false);
    const [stepsIndex, setstepsIndex] = useState<{ current: number, lastIndex: number }>(null);
    const [previousPage, setPreviousPage] = useState<number>(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (form) {
            form(currentForm);
        }
        if (config?.setForm) {
            config.setForm(currentForm)
        }
    }, [currentForm])

    useEffect(() => {
        setVisible(open);
        // Reset form when modal closes
        if (!open && currentForm) {
            currentForm.resetFields();
        }
    }, [open])

    // const onCancel = (status = false) => {
    //     try {
    //         currentForm.resetFields();

    //         if (config?.isSteps && stepsIndex?.current > 0 && status == false) {
    //             setPreviousPage(stepsIndex.current - 1);
    //             return;
    //         } else {
    //             onClose()
    //         }
    //         navigate({ search: '' });
    //     } catch (error) {
    //         console.error("Error in onCancel:", error);
    //     }
    // }

    // const forceClose = () => {
    //     currentForm.resetFields();
    //     onClose()
    //     navigate({ search: '' });
    // }

    const getSearchParams = () => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("formId");
        return searchParams;
    }

    const onCancel = (status = false) => {
        try {
            currentForm.resetFields();

            if (config?.isSteps && stepsIndex?.current > 0 && status === false) {
                setPreviousPage(stepsIndex.current - 1);
                return;
            } else {
                onClose();
            }

            // Remove only formId from query params
            const searchParams = getSearchParams();
            navigate({ search: searchParams.toString() ? `?${searchParams.toString()}` : "" });
        } catch (error) {
            console.error("Error in onCancel:", error);
        }
    };

    const forceClose = () => {
        currentForm.resetFields();
        onClose();
        const searchParams = getSearchParams();
        navigate({ search: searchParams.toString() ? `?${searchParams.toString()}` : "" });
    };

    const formSetup = () => {
        return <RenderForm
            stepsIndex={(e) => setstepsIndex(e)}
            isView={isView}
            onClose={onCancel}
            config={config}
            setLoading={(e) => setLoading(e)}
            id={id}
            previousPage={previousPage}
            formInstance={(e) => setCurrentForm(e)}
        />
    }

    // Determine the action type based on id and isView
    const getActionType = () => {
        if (isView) return 'View';
        if (id) return 'Edit';
        return 'Add';
    };

    const actionType = getActionType();
    const modalTitle = config?.modalTitle ? config.modalTitle(actionType) : actionType;

    return <>
        {isModal ? <Modal
            open={visible}
            title={modalTitle}
            onOk={isView ? undefined : () => { currentForm.submit() }}
            onCancel={forceClose}
            okText={isView ? false : "Submit"}
            cancelText={isView ? false : (config?.isSteps && stepsIndex?.current > 0) ? "Previous" : "Cancel"}
            cancelButtonProps={{ onClick: () => onCancel() }}
            width={700}
            okButtonProps={isView ? { style: { display: 'none' } } : { loading: loading }}
            maskClosable={config?.modalProps?.maskClosable !== undefined ? config.modalProps.maskClosable : true}
            {...config.modalProps}
        >
            {formSetup()}
        </Modal> : <DrawerComponent
            handleCancel={onCancel}
            isView={isView}
            forceClose={forceClose}
            loading={loading}
            maskClosable={config.maskClosable}
            title={modalTitle}
            submitForm={() => { currentForm.submit() }}
            visible={visible}
            rest={config.drawerProps}
            config={config}
            stepsIndex={stepsIndex}
        >
            {formSetup()}
        </DrawerComponent>}
    </>
}

export default FormSetup;

